import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

//
import { Button } from "react-bootstrap";
import NumberFormat from "react-number-format";

//
import { changePlanModalStep } from "../../../redux/features/plan/slice";

//
import Point from "../../../assets/img/point.png";

function PayByPoints({ user, choosedPlan, changePlanModalStep }) {
  const userPoints = () => {
    let balance = 0;
    let wallets = user.wallets;

    //
    for (let i = 0; i < wallets.length; i++) {
      const wallet = wallets[i];
      if (wallet.type === "point") {
        balance = wallet.balance;
      }
    }

    return balance;
  };

  const remaining = () => {
    let pointBalance = userPoints();
    let planPointPrice = choosedPlan.discountCode
      ? +choosedPlan.discountPrice.POINT.priceWithDiscount
      : choosedPlan.price_point;

    return pointBalance - planPointPrice;
  };

  return (
    <>
      <div className="info">
        <p>
          Points you have
          <span>
            <NumberFormat
              value={userPoints()}
              displayType={"text"}
              thousandSeparator={true}
              decimalSeparator="."
            />
            <span className="ms-1">Points</span>
          </span>
        </p>

        <p>
          Subtotal Points
          <span>
            <NumberFormat
              value={
                choosedPlan.discountCode
                  ? +choosedPlan.discountPrice.POINT.priceWithDiscount
                  : choosedPlan.price_point
              }
              displayType={"text"}
              thousandSeparator={true}
              decimalSeparator="."
            />
            <span className="ms-1">Points</span>
          </span>
        </p>
      </div>

      <p>
        Remaining Points
        <span className={remaining() < 0 ? "text-danger" : ""}>
          <img src={Point} alt="point icon" />
          <NumberFormat
            value={remaining()}
            displayType={"text"}
            thousandSeparator={true}
            decimalSeparator="."
            className={remaining() < 0 ? "text-danger" : ""}
          />
          <span className={`ms-1 ${remaining() < 0 ? "text-danger" : ""}`}>
            Points
          </span>
        </span>
      </p>

      <div className="actions ">
        <div
          className="back"
          onClick={() => changePlanModalStep("choose-method")}
        >
          Back
        </div>

        <Button
          variant="info"
          size="lg"
          disabled={remaining() < 0}
          onClick={() => changePlanModalStep("payment")}
        >
          Upgrade Account
        </Button>
      </div>
    </>
  );
}

PayByPoints.propTypes = {
  user: PropTypes.object.isRequired,
  changePlanModalStep: PropTypes.func.isRequired,
  choosedPlan: PropTypes.object.isRequired,
};

const mapDispatchToProps = {
  changePlanModalStep,
};

const mapStateToProps = (state) => ({
  user: state.userReducer.user,
  choosedPlan: state.planReducer.choosedPlan,
});

export default connect(mapStateToProps, mapDispatchToProps)(PayByPoints);
